// Maps availability group / replica / listener states to a coloured badge.
const GOOD_STATES = ['HEALTHY', 'ONLINE', 'SYNCHRONIZED', 'UP', 'CONNECTED', 'OK'];
const WARNING_STATES = ['PARTIALLY_HEALTHY', 'SYNCHRONIZING', 'RESOLVING'];
// Unknown is an absence of data, not a fault, so it must not look like one.
const UNKNOWN_STATES = ['UNKNOWN'];

function HealthBadge(props: { value: string, label?: string }) {
    const { value, label } = props;
    const normalised = value.toUpperCase();

    let badgeClass = 'bg-danger';
    if (GOOD_STATES.includes(normalised)) {
        badgeClass = 'bg-success';
    } else if (WARNING_STATES.includes(normalised)) {
        badgeClass = 'bg-warning text-dark';
    } else if (UNKNOWN_STATES.includes(normalised)) {
        badgeClass = 'bg-secondary';
    }

    const text = (label ?? value).replace(/_/g, ' ');

    return <span className={`badge ${badgeClass}`}>{text}</span>;
}

export default HealthBadge;
